import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { XuxDndItemComponent } from '../xux-dnd-item/xux-dnd-item.component';

@Component({
  selector: 'xux-dnd-item-container',
  templateUrl: './xux-dnd-item-container.component.html',
  styleUrls: ['./xux-dnd-item-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxDndItemContainerComponent implements AfterViewInit {
  @ViewChild('xuxDndItemContainer', { static: false, read: ElementRef })
  public xuxDndItemContainer: ElementRef;

  @Input()
  public componentRef: ComponentRef<XuxDndItemComponent>;

  public attached: boolean = false;

  public constructor() {}

  public ngAfterViewInit() {
    if (!this.attached && this.componentRef && this.xuxDndItemContainer) {
      this.xuxDndItemContainer.nativeElement.appendChild(
        this.componentRef.location.nativeElement,
      );

      this.componentRef.changeDetectorRef.detectChanges();

      this.attached = true;
    }
  }
}
